import { withVersions } from "v2/hocs/withVersions";
import { OnBoardingConfigs } from "../utils/configs";
import OnboardingWrapperV1 from "./OnboardingWrapper/v1";
import OnboardingWrapperV2 from "./OnboardingWrapper/v2";
import withOnboardingItem from "../hocs/withOnboardingItem";
import { OnBoardingItem as OnBoardingItemV1 } from "./OnboardingItem/v1";
import { OnBoardingItem as OnBoardingItemV2 } from "./OnboardingItem/v2";
import withSkipOnboarding from "../hocs/withSkipOnboarding";

const OnBoardingWrapper = withVersions({
  v1: withSkipOnboarding(OnboardingWrapperV1),
  v2: withSkipOnboarding(OnboardingWrapperV2),
});

const OnBoardingItem = withVersions({
  v1: withOnboardingItem(OnBoardingItemV1),
  v2: withOnboardingItem(OnBoardingItemV2),
});

const OnBoarding = {
  Wrapper: OnBoardingWrapper,
  Item: OnBoardingItem,
};

export default OnBoarding;
